/**
 * TeamSystem Impact - Auth Callback
 * Gestisce il callback dopo login Microsoft
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { apiClient } from '../../api/client';
import { useAuthStore } from '../../store/authStore';
import { logger } from '@/config/logger';

export const AuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth, setLoading } = useAuthStore();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        setLoading(true);

        // Ottieni access token da state
        const accessToken = location.state?.accessToken;

        if (!accessToken) {
          throw new Error('Access token non trovato');
        }

        // Chiama backend per login
        const response = await apiClient.post('/auth/login', {
          accessToken,
        });

        const { jwt, refreshToken, utente } = response.data;

        // Salva token, refresh token e utente nello store (persiste in localStorage)
        setAuth(jwt, utente, refreshToken);

        // Redirect a dashboard
        navigate('/dashboard', { replace: true });
      } catch (error) {
        logger.error('Errore callback autenticazione:', error);
        // Redirect a login con errore
        navigate('/login', {
          state: { error: t('auth.loginError') },
        });
      }
    };

    handleCallback();
  }, [location, navigate, setAuth, setLoading, t]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        {t('auth.loggingIn')}
      </Typography>
    </Box>
  );
};
